<template>
  <div class="Question">
    <div class="title fs20">{{problem.question}}</div>
    <div class="answer">{{problem.answer}}</div>
  </div>
</template>

<script>
 export default {
   name: '',
   props: ['problem']
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .Question{
   width: 41.9vw;
   padding-bottom: 1.5625vw;
   border-bottom: 1px solid #d6d6d6;
 }
 .answer{
   color: #5a5a5a;
   line-height:1.35vw;
 }
 .title{
   position: relative;
   color: #333333;
   /* line-height: 3.64vw; */
   height: 3.64vw;
   display: flex;
   align-items:center;
 }
 .title::before{
   content: 'Q';
   width: 1.25vw;
   height: 1.25vw;
   text-align: center;
   background-color: #526FE6;
   color: white;
   font-size: 0.73vw;
   position: absolute;
   left:-1.93vw;
   display: flex;
   align-items:center;
   justify-content:center;
 }
</style>
